<div class="flex flex-col justify-center items-center gap-4 w-full px-4">
  @for (feature of features; track feature.label) {
    <app-shop-feature-list-item class="feature-list-item w-full pb-2 border-b border-gray-200">
      <span class="feature-title w-full text-blue">
        @if (feature.value) {
          <span [class.font-normal]="!feature.valueBold"
                [class.font-semibold]="feature.valueBold">{{ feature.value }}{{ feature.unit ? ' ' + feature.unit : '' }}</span>
        }
        {{ feature.label }}
      </span>
    </app-shop-feature-list-item>
  }
</div>
